import { render, staticRenderFns } from "./section_checkboxes.vue?vue&type=template&id=487f0bba&lang=pug"
import script from "./section_checkboxes.vue?vue&type=script&lang=js"
export * from "./section_checkboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports